import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { CustomTableComponent } from "../../../shared/ui/custom-table/components/table/custom-table.component";


import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FinancialIncomeReducer } from "./store/reducers/financial-income.reducer";
import { FinancialIncomeService } from "./services/financial-income.service";
import { FinancialIncomeListV2Component } from "./components/financial-income-list/financial-income-list.components";
import { FinancialIncomeFormV2Component } from "./components/financial-income-form/financial-income-form.component";
import { FinancialIncomeEffects } from "./store/effects/financial-income.effects";
import { SharedModule } from "../../shared/shared.module";


@NgModule({
  declarations:[
    FinancialIncomeListV2Component,
    FinancialIncomeFormV2Component,
  ],
  exports:[
    FinancialIncomeListV2Component,
    FinancialIncomeFormV2Component,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    RouterModule,
    FormsModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,

    // NgRx
    StoreModule.forFeature('financialIncome', FinancialIncomeReducer),
    EffectsModule.forFeature([FinancialIncomeEffects])
  ],
  providers: [
    FinancialIncomeService
  ]
})

export class FinancialIncomeModule { }
